// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"27":"hallplan","443":"about"}[chunkId] + "." + {"27":"7745abbc","443":"f0a95b5b"}[chunkId] + ".js";
};